import checkIfGuest from './checkIfGuest'
import checkIfLogged from './checkIfLogged'
import checkOtherCharacters from './checkOtherCharacters'

export {
  checkIfGuest,
  checkIfLogged,
  checkOtherCharacters
}